import { Box, Stack, Typography } from "@mui/material";
import { usePartyQuery } from "Api/Queries/Party/usePartyQuery";
import { BlPrimarySkeletonWrapper } from "Components/Shared/BlPrimarySkeletonWrapper";
import { BlTextButton } from "Components/Shared/Buttons/BlTextButton";
import { useFormatLocale } from "Hooks/useFormatLocale";
import { AddressType } from "Infrastructure/Api/Api";
import { useCountryNameResolver } from "Translations/countryNames";
import { Resources, useResource } from "Translations/Resources";
import { getFormattedAddress } from "Utils/AddressUtils";
import { isValid } from "date-fns";
import { useTheme } from "styled-components";

type Props = {
  publicID: string;
  onEdit: () => void;
};

export const OwnerCard = ({ publicID, onEdit }: Props) => {
  const theme = useTheme();
  const { t } = useResource();
  const { getCountryName } = useCountryNameResolver();
  const format = useFormatLocale();
  const { data: owner, isLoading } = usePartyQuery(publicID);

  const address = owner?.addresses.find(
    ({ type }) => type === AddressType.Permanent,
  );

  return (
    <BlPrimarySkeletonWrapper isLoading={isLoading}>
      <Stack
        py={1}
        px={2}
        borderRadius={2}
        border={`1px solid ${theme.colors.border}`}
      >
        <Stack direction="row" justifyContent="space-between" gap={3}>
          <Typography variant="button">
            {owner?.firstName} {owner?.lastName}
          </Typography>
          <BlTextButton onClick={onEdit}>
            {t(Resources.Common.Edit)}
          </BlTextButton>
        </Stack>
        <Box>
          <Typography variant="body1" lineHeight="28px">
            {[
              owner?.birthDate && isValid(new Date(owner?.birthDate))
                ? format(new Date(owner?.birthDate), "d.M.yyyy")
                : undefined,
              address ? getFormattedAddress(address) : undefined,
              getCountryName(owner?.nationality),
            ]
              .filter(Boolean)
              .join(" • ")}
          </Typography>
        </Box>
      </Stack>
    </BlPrimarySkeletonWrapper>
  );
};
